import { GetterTree } from 'vuex'

import { AIAssistantState } from './state'

export const getters: GetterTree<AIAssistantState, any> = {
  shouldShowQuestionTypePicker: (state, _getters, _rootState, rootGetters): boolean => {
    const isProtegeAskEnabled = Boolean(rootGetters['user/isProtegeAskEnabled'])
    const isProtegeAskDocEnabled = Boolean(rootGetters['user/isProtegeAskDocEnabled'])

    return (
      isProtegeAskEnabled &&
      isProtegeAskDocEnabled &&
      !state.conversationActiveId &&
      !state.questionType
    )
  },

  totalAskDocConversationsCount: (state): number => {
    const groups = state.conversations
    return (
      (groups.today?.length ?? 0) +
      (groups.yesterday?.length ?? 0) +
      (groups.lastSevenDays?.length ?? 0) +
      (groups.lastThirtyDays?.length ?? 0)
    )
  },

  remainingAskDocConversations: (state, localGetters, _rootState, rootGetters): number | null => {
    const isFreemium = rootGetters['user/isProtegeAskDocFreemiumEnabled'] as boolean
    if (!isFreemium) return null
    const limit: number | null = rootGetters['user/protegeAskDocConversationLimit']
    if (limit === null) return null
    const used = localGetters.totalAskDocConversationsCount
    return Math.max(0, limit - used)
  },
}
